import { Entity, Field } from '@adornis/baseql/decorators.js';
import { BaseImage } from '@adornis/buildify/db/extensions/file/BaseImage.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { CampusLink } from './CampusLink.js';

@Entity()
export class CampusBaseImage extends BaseImage {
  static override _class = 'CampusBaseImage';

  @validate(nonOptional())
  @Field(() => CampusLink, { default: v => v ?? new CampusLink({}) })
  link!: CampusLink;
}
